import styled from '@emotion/styled'
import React, { useState } from 'react'

import { Dropdown } from '@/components'
import { useTicketFiltersContext } from '@/context/filters/ticketFilters/ticketFilters'
import { Priority } from '@/types/Ticket'

export const PriorityFilter = () => {
  const { setFilters, priority } = useTicketFiltersContext()
  const [dropdownExpanded, setDropdownExpanded] = useState(false)
  const priorities = Object.values(Priority)
  const handleCancel = () => {
    setDropdownExpanded(false)
  }

  const changeFilter = (val: string | null = null) => {
    setDropdownExpanded(false)
    setFilters({ priority: val })
  }

  return (
    <Dropdown
      className="hidden w-full md:w-auto lg:flex"
      expanded={dropdownExpanded}
      headerTitle="Priority"
      onHideDropdown={handleCancel}
      renderHeader={() => <div></div>}
      selected={!!priority}
      setExpanded={setDropdownExpanded}
    >
      <FilterOptionsStyled>
        <ul>
          <li className={`${!priority ? 'selected' : ''}`} onClick={() => changeFilter()} role={'presentation'}>
            All
          </li>
          {priorities.map((val, i) => (
            <li
              className={`${priority === val ? 'selected' : ''}`}
              key={i}
              onClick={() => changeFilter(val)}
              role={'presentation'}
            >
              {val}
            </li>
          ))}
        </ul>
      </FilterOptionsStyled>
    </Dropdown>
  )
}

export const FilterOptionsStyled = styled.div`
  width: 13rem;

  ul {
    width: 100%;
    padding-top: 0.5rem;
    padding-bottom: 0.25rem;
  }
  li {
    &.selected {
      background-color: #e7e6e4;

      &:hover {
        background-color: #e7e6e4;
      }
    }
    margin-bottom: 0.25rem;
    width: 100%;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    cursor: pointer;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    line-height: 1;
    &:hover {
      background-color: #f3f3f2;
    }
  }
`
